<template>
  <div class="withdraw">
    <div class="hotTip">
      <div>
        <img src="@/assets/images/user/blueTipIcon.png"/>
        <p>单笔提现金额不得小于100元，最高不得大于50000元 提现申请成功后，将在7个工作日到达指定账户</p>
      </div>
    </div>
    <div class="aboutBox">
      <p class="title">提现银行卡</p>
      <div class="item">
        <span class="gray">持卡人</span>
        <span>{{withdrawalInfo.Name || '无'}}</span>
      </div>
      <div class="item">
        <span class="gray">银行卡<img src="@/assets/images/user/grayTipIcon.png"/></span>
        <div class="selectedBank" @click="enterPersonalSetting()">
          <span v-if="withdrawalInfo.BankName && withdrawalInfo.BankCardNo">{{withdrawalInfo.BankName}}({{BankCardNoSub}})</span>
          <span v-else>请选择</span>
          <img src="@/assets/images/user/rightArrow.png" class="arrowIcon"/>
        </div>
      </div>
    </div>
    <div class="aboutBox">
      <p class="title">提现金额</p>
      <div class="mainBox">
        <div class="withdrawBox">
          <div class="left">
            <span>¥</span>
            <input v-model="currentAccount" placeholder="0"/>
          </div>
          <div class="right">手续费<em>0.00</em>元</div>
        </div>
        <div class="withdrawAmount">
          <span>本次可提现<em>{{withdrawalInfo.AvailableAccount}}</em>元</span>
          <span @click="setAccount()"><em>全部提现</em></span>
        </div>
      </div>
    </div>
    <div class="aboutBox">
      <p class="title">手机验证</p>
      <div class="mainBox">
        <div class="withdrawBox">
          <div class="left">{{withdrawalInfo.Telephone}}</div>
          <div class="right" :class="['sendBtn',isSend ? 'disabled' : '']" @click="sendCode">{{isSend ? sendNum + '秒后重发' : '发送验证码'}}</div>
        </div>
        <input class="code" type="text" v-model="validateCode" placeholder="请输入验证码">
      </div>
    </div>
    <div class="withdrawBtn" @click="confirm()">确认提现</div>

  </div>
</template>
<script>
  import {
    getWithdrawalInfo,
    sendValidateCode,
    cashWithdrawal
  } from "@/utils/api";
  import {apiMode} from "@/utils/env";
  export default {
    name: "withdraw",
    data() {
      return {
        withdrawalInfo: {
          Name: "",
          BankCardNo: "",
          Telephone: "",
          AvailableAccount: "0.00"
        },
        currentAccount: "", //当前提现金额
        validateCode:"", //验证码
        isSend:false, //是否发送验证码
        sendNum: 60, //重新发送时间
        timeID:0, //计时器id
      };
    },
    mounted() {
      this.initData();
    },
    computed: {
      BankCardNoSub: function () {
        let No = this.withdrawalInfo.BankCardNo || "";
        if(No){
          return No.substring(No.length-4);
        }
        else{
          return No
        }
      }
    },
    methods: {
      async initData() {
        let res = await getWithdrawalInfo();
        if (res.Code == 100) {
          if(res.Data.Name){
            res.Data.Name = '*' + res.Data.Name.slice(1);
          }
          this.withdrawalInfo = res.Data;
        }
      },
      setAccount() {
        if( this.withdrawalInfo.AvailableAccount == 0){
          return
        }
        this.currentAccount = this.withdrawalInfo.AvailableAccount;
      },
      async sendCode(){
        if (this.isSend) {
          return;
        }
        let res = await sendValidateCode({
          data: {
            Telephone:this.withdrawalInfo.Telephone
          }
        });
        if (res.Code === 100) {
          if (apiMode == "build") {
            this.flexible.showToast({
              type: "success ",
              content: "短信发送成功！",
            });
          }
          this.isSend = true;
          this.sendNum = 60;
          this.timeID = setInterval(this.awaitSend.bind(this), 1000);
        }
      },
      awaitSend() {
        this.sendNum = this.sendNum - 1;
        if (this.sendNum <= 0) {
          clearInterval(this.timeID);
          this.isSend = false;
          this.timeID = 0;
        }
      },
      async confirm(){
        if(!this.withdrawalInfo.Name || !this.withdrawalInfo.BankCardNo){
          this.flexible.showToast({
            type: 'fail',
            content: "请先完善用户信息！",
          });
          return;
        }
        if(Number(this.currentAccount) < 100){
          this.flexible.showToast({
            type: 'fail',
            content: "提现金额不能少于100元！",
          });
          return;
        }
        if( this.currentAccount>this.withdrawalInfo.AvailableAccount ){
          this.flexible.showToast({
            type: 'fail',
            content: "提现金额超限！",
          });
          return;
        }
        if(!this.validateCode){
          this.flexible.showToast({
            type: 'fail',
            content: "验证码不能为空！",
          });
          return;
        }
        let res = await cashWithdrawal({
          data: {
            BankCardNo:this.withdrawalInfo.BankCardNo,
            Telephone:this.withdrawalInfo.Telephone,
            Amount:this.currentAccount,
            ValidateCode:this.validateCode
          }
        });
        if(res.Code == 100){
          let that = this;
          that.flexible.showToast({
            type: "success ",
            content: "提现成功！",
            duration: 1000,
            success: function () {
              that.$router.replace({ path: "/wallet" });
            }
          });
        }
      },
      enterPersonalSetting(){
        this.$router.replace({ path: "/personalSetting" });
      }
    }
  };
</script>
<style lang="scss" scoped type="text/scss">
  .withdraw {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding: 110px 35px 35px;
    box-sizing: border-box;
    background: #fff;
    overflow: scroll;
    .hotTip {
      padding-top: 35px;
      margin-bottom: 40px;
      >div{
        display: flex;
        img {
          width: 32px;
          height: 32px;
          margin-right: 15px;
          margin-top: 10px;
        }
        p {
          flex: 1;
          color: #027fff;
          font-size: 26px;
        }
      }
    }
    .aboutBox {
      padding: 30px 0;
      border-radius: 6px;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
      -webkit-box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
      margin-top: 26px;
      .title {
        font-size: 36px;
        color: #000000;
        font-weight: bold;
        border-left: 10px solid #027fff;
        padding-left: 22px;
      }
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 50px 30px 0;
        font-size: 26px;
        .gray {
          display: flex;
          align-items: center;
          color: #9f9f9f;
          img {
            width: 24px;
            height: 24px;
            margin-left: 5px;
          }
        }
        .selectedBank {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          width: 350px;
          height: 70px;
          padding-right: 10px;
          background: #ebebeb;
          .bankIcon {
            width: 40px;
            height: 40px;
          }
          .arrowIcon {
            width: 32px;
            height: 32px;
          }
          span {
            color: #000;
            font-size: 26px;
            margin: 0 12px;
          }
        }
      }
      .item:last-child {
        padding-bottom: 28px;
      }
      .mainBox {
        padding: 0 30px;
        .withdrawBox {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          padding: 20px 0;
          border-bottom: 1px solid #dcdcdc;/*no*/
          font-size: 28px;
          .left {
            display: flex;
            align-items: flex-end;
            span {
              font-size: 34px;
              margin-bottom: 7px;
              margin-right: 10px;
            }
            input {
              width: 400px;
              font-size: 46px;
              font-weight: bold;
            }
            ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
              color: #000000;
            }
            :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
              color: #000000;
            }
            ::-moz-placeholder { /* Mozilla Firefox 19+ */
              color: #000000;
            }
            :-ms-input-placeholder { /* Internet Explorer 10-11 */
              color: #000000;
            }
          }
          .right {
            font-size: 26px;
            color: #9f9f9f;
          }
          .sendBtn {
            padding: 20px;
            border: solid 1px #027fff;/*no*/
            color: #027fff;
          }
          .sendBtn.disabled {
            border-color: #999;
            color: #999;
          }
        }
        .withdrawAmount{
          display: flex;
          justify-content: space-between;
          font-size: 26px;
          span {
            margin-top: 20px;
            color: #9f9f9f;
          }
        }
        .code{
          padding-top: 20px;
          box-sizing: border-box;
        }
        em{
          font-style: normal;
          color: #027fff;
        }
      }
    }
    .withdrawBtn {
      width: 100%;
      height: 90px;
      text-align: center;
      line-height: 90px;
      background: #027fff;
      color: #fff;
      font-size: 28px;
      margin-top: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/withdraw.vue